import React, { createRef, useState, useEffect, useRef, useCallback } from 'react';
import { INDEX_URL, CUST, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import * as request from "../../services/FetchService";
import { fixDate } from '../../helpers/helperFunctions';
import Button from '../Buttons/Button';
import SafetyModal from '../Modals/SafetyModal';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import SafetyRow from '../Safety/SafetyRow';
import SafetyRowPlaceholder from '../Safety/SafetyRowPlaceholder';
import axios from 'axios';
import { useContextData } from '../ContextData';
import { useIsMobile } from '../../helpers/customHooks';
import NewButton from '../Buttons/NewButton';

const Safety = (props) => {
	const { t } = useTranslation();
    const [historyList, setHistoryList] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [type, setType] = useState()
    const [totalPages, setTotalPages] = useState(0)
    const [loading, setLoading] = useState(true)
    const [currentPage, setCurrentPage] = useState(1)
    const { setAccessToken, setDeviceListMap, setDeviceListCompact } = useContextData();
    const listInnerRef = createRef();
    const sentinelRef = useRef(null);
    const MOBILE = useIsMobile();
    const navigate = useNavigate();


    const hasMore = totalPages === -1 ? true : currentPage < totalPages;

    // const onScroll = () => {
	// 	if(listInnerRef.current){
	// 		const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
	// 		if (scrollTop + clientHeight === scrollHeight && !loading) {
	// 			if(totalPages > currentPage){
	// 				setLoading(true)
	// 				getLoginHistory(currentPage + 1)
	// 				setCurrentPage(currentPage + 1)
	// 				// setEventList(eventList => [...eventList, ...eventScrollList[page]])
	// 			}
	// 		}
	// 	}
	// }

    const loadMore = useCallback(() => {
        if (loading) return;
        if (!hasMore) return;

        setLoading(true);

        const next = currentPage + 1;
		getLoginHistory(currentPage + 1)
		setCurrentPage(next);
    }, [loading, hasMore, currentPage]);


    const onScroll = useCallback(() => {
        const el = listInnerRef.current;
        if (!el || loading ) return;
        const { scrollTop, scrollHeight, clientHeight } = el;
        if (scrollTop + clientHeight >= scrollHeight - 2) {
            loadMore();
        }
    }, [loading, loadMore]);



    useEffect(() => {
        if(!MOBILE) return;
        const rootEl = !MOBILE ? listInnerRef.current : null;

        const observer = new IntersectionObserver(
            (entries) => {
                const [entry] = entries;
                if (entry.isIntersecting) {
                    loadMore();
                }
            },
            {
                root: rootEl, // null = viewport (mobile)
                rootMargin: "200px",
                threshold: 0,
            }
        );

        if (sentinelRef.current) observer.observe(sentinelRef.current);
        return () => observer.disconnect();
    }, [MOBILE, loadMore]);



    useEffect(() => {
		window.addEventListener('scroll', onScroll)
        getLoginHistory()

		return() => {
			window.removeEventListener('scroll', onScroll)
		}
	}, []);

    const getLoginHistory = (page = currentPage) => {
        let data = {
            page: page,
            limit: 100
        }
        let url;
        if(process.env.REACT_APP_FLAVOR === "bike" || process.env.REACT_APP_FLAVOR === "alco"){
            url = "login/history"
        }else{
            url = "login/history"

        }
        request.post("", url, data).then((response) => {
            if(response.status === 200){
                setLoading(false)
                setHistoryList(historyList => [...historyList, ...response.data.data])
                setTotalPages(response.data.totalPages)
            }else{
                setLoading(false)
            }
        })
    }

    const openModal = (type) => {
        setType(type)
        setShowModal(!showModal)
    }

    const clearHistory = () => {
        let ids = historyList.map((history) => history.id);
        let data = {
            loginid: ids,
            deleteAll: true
        }
        request.post("", "login/delete", data).then((response) => {
            if(response.data){
                setHistoryList([])
                setShowModal(false)
                getLoginHistory()
                toast.success(t("toast.success"))

            }else{
                const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
            }
        })
    }

    let cancelTokenSource = axios.CancelToken.source();
    // Function to cancel all ongoing requests
    const cancelOngoingRequests = () => {
        cancelTokenSource.cancel('Logout initiated: Cancelling all ongoing requests.');
        // Create a new CancelToken source for future requests
        cancelTokenSource = axios.CancelToken.source();
    };

    const logoutAll = () => {
        request.get("login/signOutAll").then((response) => {
            if(response.data){
                cancelOngoingRequests(); // Cancel ongoing requests
                localStorage.clear()
                setAccessToken(null)
                setDeviceListMap([])
                setDeviceListCompact([])
                navigate("/devices")
            }
        })
    }
    
    return(
        <>
        {/* <p className="thin">{t("settings.safety")}</p> */}
        <p className="mb-1 bold">{t("settings.login_history")}</p>
        <div ref={listInnerRef} onScroll={() => onScroll()} className="d-flex rounded24 flex-column scrollable-y">
            {loading &&
              <SafetyRowPlaceholder />
            }
            {historyList && historyList.map((history, index) => (
                <SafetyRow key={index} history={history} index={index} />
            ))}
            <div ref={sentinelRef} style={{ height: 1 }} />
        </div>
        {historyList && historyList.length === 0  && !loading &&
            <div className="p-3 w-100">
                <h3 className="regular text-center">{t("settings.no_history")}</h3>
            </div>
        }
        {historyList && !loading &&
            <div className="d-flex justify-content-end mt-3">
                <NewButton onClick={() => openModal("clear")}>{t("settings.clear_history")}</NewButton>
                <NewButton onClick={() => openModal("logout")} btnClass="btn-danger ms-2 white-white">{t("settings.logout_all_sessions")}</NewButton>
            </div>
            }
        <SafetyModal show={showModal} clearHistory={() => clearHistory()} logoutAll={() => logoutAll()} type={type} onClose={() => setShowModal(!showModal)} />

        </>
    )
}

export default Safety;